import {defineStore} from 'pinia';

export const useUiStore = defineStore('ui', {
	state: () => ({
		darkMode: false,
	}),
	actions: {
		initDarkMode() {
			let paramDarkMode = localStorage.getItem('darkMode');
			if(paramDarkMode === null) {
				localStorage.setItem('darkMode', '0');
				paramDarkMode = '0';
			}
			this.darkMode = paramDarkMode === '1';
			if(paramDarkMode === '2') {
				let now = new Date();
				let hours = now.getHours();
				this.darkMode = hours >= 18 || hours < 6;
			}
			document.documentElement.classList[this.darkMode ? 'add' : 'remove']('dark');
			document.documentElement.style.setProperty('--status-color-qr', this.darkMode ? '#1783f8' : '#0752A3');
			document.documentElement.style.setProperty('--status-color-delivery', this.darkMode ? '#1bd5fb' : '#03A5CB');
			document.documentElement.style.setProperty('--status-color-takeaway', this.darkMode ? '#b445ff' : '#7b03cb');
			document.documentElement.style.setProperty('--status-color-counter', this.darkMode ? '#ff8539' : '#e36e28');
		},
	},
});